"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _tslib = require("tslib");
var _react = _interopRequireDefault(require("react"));
var _Layout = require("../../../Layout");
var _defaultmap = _interopRequireDefault(require("./defaultmap.png"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var SkeletonMap = function SkeletonMap(_a) {
  var _b = _a.variant,
    variant = _b === void 0 ? 'primary' : _b,
    props = (0, _tslib.__rest)(_a, ["variant"]);
  return _react.default.createElement(_Layout.Box, (0, _tslib.__assign)({
    __themeKey: "skeletons",
    variant: variant + ".map",
    __css: {
      backgroundColor: 'rgba(0, 0, 0, 0.1)',
      backgroundImage: "url(" + _defaultmap.default + ")",
      backgroundRepeat: 'repeat',
      height: '100%',
      minHeight: '10px',
      width: '100%'
    }
  }, props));
};
var _default = SkeletonMap;
exports.default = _default;